import {dataHooks} from '@wix/data-hooks'

export const reservationAddOnFormDataHooks = dataHooks<{
  root: {}
  location: {}
  partySize: {}
  date: {}
  time: {}
  area: {}
}>('reservation-addon-form')
